export default __webpack_public_path__ + "7c2680f99e453b3551854f14f9520388.png";